/**
 * LandingRouter — resolves the institution's default chapter and renders its
 * landing page directly at `/`. Falls back to <HomePage/> when scope resolve
 * fails (e.g. database not yet seeded), so the live reunion site keeps
 * working regardless of backend state.
 */

import { useEffect, useState } from 'react';
import { ScopeProvider } from '@/contexts/ScopeContext';
import { ChapterLandingPage } from '@/pages/public/ChapterLandingPage';
import { HomePage } from '@/pages/public/HomePage';

interface Resolved {
  defaultChapterSlug?: string;
}

export function LandingRouter() {
  const [resolved, setResolved] = useState<Resolved | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const apiBase =
      (import.meta as unknown as { env: Record<string, string> }).env.VITE_API_URL ??
      'http://localhost:3001';
    fetch(`${apiBase}/api/scope/resolve?institution=navarasam`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((data) => setResolved({ defaultChapterSlug: data.institution?.defaultChapterSlug }))
      .catch(() => setFailed(true));
  }, []);

  if (failed) return <HomePage />;
  if (!resolved) {
    return (
      <div className="container mx-auto px-4 py-12 text-center text-white/60">
        Loading…
      </div>
    );
  }
  if (!resolved.defaultChapterSlug) return <HomePage />;

  return (
    <ScopeProvider defaultChapterSlug={resolved.defaultChapterSlug}>
      <ChapterLandingPage />
    </ScopeProvider>
  );
}

export default LandingRouter;
